<template>

    <div class="c-form_row" :class="getClasses">
        <slot></slot>
    </div>

</template>


<script>

export default {

    name: 'FormRow',

    props: {
        align: String,
        inline: Boolean,
        narrow: Boolean
    },

    computed: {
        getClasses() {
            return {
                ['c-form_row--narrow']: this.narrow,
                ['c-form_row--' + this.align]: this.align,
            }
        }
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-form_row {
    width: 100%;
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;

    &--center {
        align-items: center;
    }
    &--right {
        align-items: flex-end;
    }
    &--between {
        flex-direction: row-reverse;
        justify-content: space-between;

        .c-btn {
            margin-right: 5px;

            &:first-of-type {
                margin-right: 0;
            }
        }
    }
    @include bp($screen-sm) {
        .c-btn {
            flex-shrink: initial;
        }
    }
}

</style>


